import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { Header } from "./components/Header";
import { HeaderAffiliateBanner, FooterAffiliateBanner } from "./components/AffiliateBanners";
import { LandingPage } from "./pages/LandingPage";
import { Dashboard } from "./pages/Dashboard";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { ProfilePage } from "./pages/ProfilePage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <div className="min-h-screen bg-[#071d36] flex flex-col">
                    <Header />
                    
                    {/* AirHelp Affiliate Banner - Below Header */}
                    <HeaderAffiliateBanner />
                    
                    <main className="flex-1">
                        <Routes>
                            <Route path="/" element={<LandingPage />} />
                            <Route path="/tracker" element={<Dashboard />} />
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/register" element={<RegisterPage />} />
                            <Route path="/profile" element={<ProfilePage />} />
                            <Route path="/reset-password" element={<ResetPasswordPage />} />
                        </Routes>
                    </main>
                    
                    {/* AirHelp Affiliate Banner - Footer */}
                    <FooterAffiliateBanner />
                    
                    <Toaster 
                        position="top-right" 
                        theme="dark"
                        toastOptions={{
                            style: {
                                background: '#1e293b',
                                border: '1px solid #334155',
                                color: '#ffffff'
                            }
                        }}
                    />
                </div>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
